import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import CompetitionsList, {
  CompetitionsListEditionProvider,
} from 'src/common/components/CompetitionsList';
import EditorDialogShell from 'src/common/components/modals/EditorDialogShell';
import { IEdition } from 'src/interfaces/Edition';

type Props = {
  edition: IEdition;
  open: boolean;
  onClose: () => void;
};

const EditionCompetitionsModal = ({ edition, open, onClose }: Props) => {
  const { t } = useTranslation();
  const hasCompetitions = (edition.competitions?.length ?? 0) > 0;

  return (
    <EditorDialogShell
      id="edition-competitions"
      open={open}
      onClose={onClose}
      title={`${t('editions.competitions')} (${edition.year})`}
      maxWidth="md"
    >
      {hasCompetitions ? (
        <CompetitionsListEditionProvider editionId={edition.id}>
          <CompetitionsList variant="list" includeUnpublished />
        </CompetitionsListEditionProvider>
      ) : (
        <Typography variant="body2" color="text.secondary">
          -
        </Typography>
      )}
    </EditorDialogShell>
  );
};

export default EditionCompetitionsModal;
